import React, { createContext, useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

const ChatContext = createContext(null);

export const ChatProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [minimized, setMinimized] = useState(false);
    const [channel, setChannel] = useState(null);

    const openWithChannel = useCallback((ch) => {
        const url = typeof ch === 'string' ? ch : ch?.url;
        if (!url) return;
        setChannel({ url });
        setMinimized(false);
        setOpen(true);
    }, []);

    const close = useCallback(() => {
        setOpen(false);
        setChannel(null);
    }, []);

    const minimize = useCallback(() => {
        setMinimized(true);
        setOpen(false);
    }, []);

    const restore = useCallback(() => {
        setMinimized(false);
        setOpen(true);
    }, []);

    const value = {
        open,
        minimized,
        channel,
        setChannel,
        openWithChannel,
        close,
        minimize,
        restore,
    };

    return (
        <ChatContext.Provider value={value}>
            {children}
        </ChatContext.Provider>
    );
};

export const useChat = () => useContext(ChatContext);

ChatProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ChatContext;
